<app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader>

<div class="full body">
    <app-mentornavbar></app-mentornavbar>



<div class="main">
    <div class="form">
        <h1 style="display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;"><span class="headi">LOGIN</span></h1>
        <form [formGroup]="firstFormGroup" style="border-radius: 1.5rem;" class="main-form">
            <br>
            <mat-form-field appearance="outline" class="input-field">
              <input matInput placeholder="Team ID*" formControlName="id" required>
              <mat-error *ngIf="firstFormGroup.controls['id'].hasError('required')">
                  ID is required!
              </mat-error>
            </mat-form-field><br>
            <mat-form-field appearance="outline"  class="input-field">
              <input matInput formControlName="password" placeholder="Enter your Team password*" [type]="hide ? 'password' : 'text'"  name="password" required>
              <button style="color: black;" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="firstFormGroup.controls['password'].hasError('required')">
                Password is required!
            </mat-error>
            </mat-form-field>
            <div class="butbut">
              <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
              <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
              <button class="green-button" mat-button (click)="submit()">Submit</button>
              <h5>Please check your registered Email ID for login credentials</h5>
            </div>
          </form>
    <div class="foot">
        <div>
            <h5><a style="color: white;" (click)="register()">New User? Register Now</a></h5>
        </div>
        <div class="end">
            <h5><a style="color: white;" [routerLink]="['/reset']">Forgot password, Click here</a></h5>
        </div>
    </div>
    </div>


</div>

<div>
    <app-footer></app-footer>
</div>
</div>